import { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { goToAuthHub } from '../authHub';

/** Legacy /login — Local Partner sign-in is on auth.gosnel.com. */
export default function LoginPage() {
  useEffect(() => {
    goToAuthHub();
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        bgcolor: '#f8fafc',
      }}
    >
      <CircularProgress size={40} sx={{ color: '#0f766e' }} />
      <Typography variant="body2" color="text.secondary">
        Redirecting to GoSnel Sign in…
      </Typography>
    </Box>
  );
}
